import { combineReducers } from 'redux';

import auth from './auth/reducer';
import slides from './slides/reducer';

export default combineReducers({
  auth,
  slides,
});
